// extracted by mini-css-extract-plugin
module.exports = {"plan-perks":"plan-list_plan-perks__1N5jN","plan-perks__list":"plan-list_plan-perks__list__KzKmZ","plan-perks__item":"plan-list_plan-perks__item__3JMda"};